import api from "../api";
import { auth, property } from "../api_endpoints";


export const LoginUser=async(data)=>{
  try {
    const res= await api.post(auth.login, data,{
      headers: {
        'Content-Type': 'application/json',
      },
    } );
    return res
    
  } catch (error) {
    return error
  }
}

export const RegisterUser=async(data)=>{
  try {
    const res= await api.post(auth.register, data,{
      headers: {
        'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const ProfileUser=async(token)=>{
  try {
    const res= await api.get(auth.getProfile,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const UserOrderHistory=async(token)=>{
  try {
    const res= await api.get(auth.getHistory,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const logoutUser=async(token)=>{
  try {
    const res= await api.post(auth.logoutUser,{},{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );


    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const getProperties=async(token)=>{
  try {
    const res= await api.get(property.getProperty,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const getGalleries=async(token)=>{
  try {
    const res= await api.get(property.getGallery,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const CreateOrder = async (data, token) => {
  try {
    console.log("DATA:", data);
    console.log("TOKEN:", token);

    const res = await api.post(
      property.createOrder,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (error) {
    console.log("API ERROR:", error?.response?.data || error.message);
    return error;
  }
};

export const VerifyPayment=async(data,token)=>{
  try {
    const res= await api.post(property.verifyPayment,data,{
      headers: {
        'Authorization':`Bearer ${token}`,
       'content-type': 'application/json'
      },
    } );


    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}


